import {MagazineService} from "../service/MagazineService";
import {InvestService} from "../service/InvestService";
import {OnOfficeService} from "../service/OnOfficeService";
import {ErlService} from "../service/ErlService";
import {FacebookTracking} from "../helper/FacebookTracking";
import {GoogleTracking} from "../helper/GoogleTracking";
import {DataStore} from "../service/DataStore";

interface AppContextInterface {
    magazineService: MagazineService,
    investService: InvestService,
    onOfficeService: OnOfficeService,
    erlService: ErlService,
    facebookTracking: FacebookTracking,
    googleTracking: GoogleTracking,
    dataStore: DataStore
}

export const AppContext: AppContextInterface = {
    magazineService: new MagazineService(),
    investService: new InvestService(),
    onOfficeService: new OnOfficeService(),
    erlService: new ErlService(),
    facebookTracking: new FacebookTracking(),
    googleTracking: new GoogleTracking(),
    dataStore: new DataStore()
}
